export const setListaAlumnosUNI = (state, payload) => {
  state.listaAlumnosUNI = payload;
};

export const setListaAlumnosUNIbackup = (state, payload) => {
  state.listaAlumnosUNIbackup = payload;
};

export const setAdminData = (state, payload) => {
  state.adminData = payload;
};

export const setEditAlumnoDialog = (state, payload) => {
  state.editAlumnoDialog = payload;
};

export const setEditAdministradorDialog = (state, payload) => {
  state.editAdministradorDialog = payload;
};

export const setCreateAdministradorDialog = (state, payload) => {
  state.createAdministradorDialog = payload;
};

export const setCreateNewDialog = (state, payload) => {
  state.createNewDialog = payload;
};

export const setShowAlumnoInfoDialog = (state, payload) => {
  state.showAlumnoInfoDialog = payload;
};

export const setNoChangeEdit = (state, payload) => {
  state.noChangeEdit = payload;
};

export const setSelectedAlumnoEdit = (state, payload) => {
  state.selectedAlumnoEdit = payload;
};

export const setSelectedAlumnoInfo = (state, payload) => {
  return (state.selectedAlumnoInfo = payload);
};

export const setSelectedAdministradorEdit = (state, payload) => {
  state.selectedAdministradorEdit = payload;
};

export const setSelectedNewEdit = (state, payload) => {
  state.selectedNewEdit = payload;
};

export const setEstadisticaNuevosIngresos = (state, payload) => {
  state.estadisticaNuevosIngresos = payload;
};

export const setListaAdministradores = (state, payload) => {
  state.listaAdministradores = payload;
};

export const setDrawerState = (state, value) => {
  return (state.drawer = value);
};

export const setListaNews = (state, payload) => {
  state.listaNews = payload;
};
